export default {"src":"__ASTRO_ASSET_IMAGE__Bw8uwrT8__","width":48,"height":48,"format":"svg"}